import { render } from "./Lottery.vue?vue&type=template&id=19644018"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"
script.render = render

export default script